import { createCollectionReducer } from 'ext/lib/collections';
import { TYPE } from './actions';

export default createCollectionReducer(TYPE);

export const selectTags = state => state[TYPE];
export const selectTag = (state, id) => selectTags(state)[id];
